// extracted by mini-css-extract-plugin
export var banner = "_3u-0";
export var icon = "_3u-1";
export var message = "_3u-2";